import React from 'react';

const Logo: React.FC = () => {
  return (
    <img 
      src="/newlogo.png" 
      alt="Elite Shape Personal Training - Kelvin Kirk" 
      className="h-16"
    />
  );
};

export default Logo;